import * as React from "react"
import { Typography } from "@mui/material"

export default function brandColumn() {
    return {
        name: "brandName",
        label: "Brand",
        options: {
            filterType: "textField",
            setCellHeaderProps: () => ({ style: { textAlign: "left" } }),
            setCellProps: () => ({ style: { textAlign: "left" } }),
            filterOptions: {
                logic: (value, filterValue, row) => {
                    if (!filterValue || filterValue.length === 0) return false
                    const searchTerm = filterValue[0].toLowerCase()
                    const brandName = (row.brandName || "").toLowerCase()
                    const displayName = (row.displayName || "").toLowerCase()
                    return !brandName.includes(searchTerm) && !displayName.includes(searchTerm)
                }
            },
            customBodyRender: (value) => (
                <Typography fontWeight={600} color="text.primary">
                    {value || "-"}
                </Typography>
            )
        }
    }
}
